import { render, staticRenderFns } from "./skin.vue?vue&type=template&id=01573918&"
import script from "./skin.vue?vue&type=script&lang=js&"
export * from "./skin.vue?vue&type=script&lang=js&"
import style0 from "./skin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports